export default __webpack_public_path__ + "static/media/middle-icon.83fc98bf.png";